import { render, staticRenderFns } from "./EmptyLayout.vue?vue&type=template&id=b6f9acf2"
import script from "./EmptyLayout.vue?vue&type=script&lang=js"
export * from "./EmptyLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b6f9acf2')) {
      api.createRecord('b6f9acf2', component.options)
    } else {
      api.reload('b6f9acf2', component.options)
    }
    module.hot.accept("./EmptyLayout.vue?vue&type=template&id=b6f9acf2", function () {
      api.rerender('b6f9acf2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/layouts/EmptyLayout.vue"
export default component.exports